import * as types from '../constants/uiConstants';
import { writeDemoModePreference } from 'utils/demoModeStorage';

export const openMenuItem = (menu) => ({
  type: types.OPEN_MENU,
  payload: menu,
});

export const openDetails = (details) => ({
  type: types.OPEN_DETAILS,
  payload: details,
});

export const collapsedAction = (data) => ({
  type: types.SET_COLLAPSED,
  payload: data,
});

export const changeDemoAction = (demo) => {
  const enabled = Boolean(demo);
  writeDemoModePreference(enabled);
  return {
    type: types.CHANGE_DEMO,
    payload: enabled,
  };
};
